import { CaseArtifactTypes } from '../enums/index';

export const automatableTypes = new Set<CMxAPI.CaseArtifactType>([
  CaseArtifactTypes.PREDICTION,
  CaseArtifactTypes.PROCESSED,
  CaseArtifactTypes.SUBMITTED
]);
